import { render, staticRenderFns } from "./Ownership.vue?vue&type=template&id=69b3280c&scoped=true&"
import script from "./Ownership.vue?vue&type=script&lang=js&"
export * from "./Ownership.vue?vue&type=script&lang=js&"
import style0 from "./Ownership.vue?vue&type=style&index=0&id=69b3280c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b3280c",
  null
  
)

export default component.exports